// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Admin_ba__num__BLVUo {
  width: 18rem;
  background-color: var(--color-white);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 6rem;
  border-radius: 1rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
}
.Admin_ba__card__L7K1V {
  background-color: var(--color-white);
  height: 25rem;
  width: 100%;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.15);
}
.Admin_ba__card__L7K1V:hover {
  border: 2px solid var(--color-primary);
  background: linear-gradient(to right bottom, var(--color-white), var(--color-light) 100%);
}
.Admin_ba__card__L7K1V > :not(:last-child) {
  margin-bottom: 1rem;
}
.Admin_ba__card__L7K1V img {
  height: 6rem;
}
.Admin_ba__card_btn__1YTs4 {
  width: 90%;
  background-color: var(--color-dark);
  color: var(--color-white);
  font-size: var(--default-font-small);
  font-weight: 700;
  text-align: center;
  padding: 0.5rem 1rem;
  border-radius: 0.8rem;
  cursor: pointer;
}
.Admin_ba__card_btn__1YTs4:hover {
  background-color: var(--color-dark-2);
}
.Admin_ba__permits__1y\\+vu {
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  width: 38rem;
  padding-left: 2rem;
}
.Admin_ba__permits__1y\\+vu > * {
  margin-bottom: 1rem;
}
.Admin_ba__permits_middle__yfnyz {
  display: flex;
  width: 38rem;
  justify-content: center;
  margin-top: 2rem;
}
.Admin_ba__permits_list__tdASr {
  width: 38rem;
  display: flex;
  flex-direction: column;
  font-size: var(--default-font-small);
  margin-bottom: 2rem;
}
.Admin_ba__permits_list__tdASr > * {
  margin-right: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Admin/Admin.module.scss"],"names":[],"mappings":"AACC;EACC,YAAA;EACA,oCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,4CAAA;AAAF;AAGC;EACC,oCAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,4CAAA;AADF;AAGE;EACC,sCAAA;EACA,yFAAA;AADH;AAQE;EACC,mBAAA;AANH;AASE;EACC,YAAA;AAPH;AAUE;EACC,UAAA;EACA,mCAAA;EACA,yBAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,eAAA;AARH;AAUG;EACC,qCAAA;AARJ;AAcC;EACC,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AAZF;AAcE;EACC,mBAAA;AAZH;AAeE;EACC,aAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;AAbH;AAgBE;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,oCAAA;EACA,mBAAA;AAdH;AAgBG;EACC,kBAAA;AAdJ","sourcesContent":[".ba {\n\t&__num {\n\t\twidth: 18rem;\n\t\tbackground-color: var(--color-white);\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\theight: 6rem;\n\t\tborder-radius: 1rem;\n\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t}\n\n\t&__card {\n\t\tbackground-color: var(--color-white);\n\t\theight: 25rem;\n\t\twidth: 100%;\n\t\tborder-radius: 1rem;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tbox-shadow: 0px 6px 15px rgba(0, 0, 0, 0.15);\n\n\t\t&:hover {\n\t\t\tborder: 2px solid var(--color-primary);\n\t\t\tbackground: linear-gradient(\n\t\t\t\tto right bottom,\n\t\t\t\tvar(--color-white),\n\t\t\t\tvar(--color-light) 100%\n\t\t\t);\n\t\t}\n\n\t\t& > :not(:last-child) {\n\t\t\tmargin-bottom: 1rem;\n\t\t}\n\n\t\timg {\n\t\t\theight: 6rem;\n\t\t}\n\n\t\t&_btn {\n\t\t\twidth: 90%;\n\t\t\tbackground-color: var(--color-dark);\n\t\t\tcolor: var(--color-white);\n\t\t\tfont-size: var(--default-font-small);\n\t\t\tfont-weight: 700;\n\t\t\ttext-align: center;\n\t\t\tpadding: 0.5rem 1rem;\n\t\t\tborder-radius: 0.8rem;\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: var(--color-dark-2);\n\t\t\t\t// box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.12);\n\t\t\t}\n\t\t}\n\t}\n\n\t&__permits {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tmargin-top: 2rem;\n\t\twidth: 38rem;\n\t\tpadding-left: 2rem;\n\n\t\t& > * {\n\t\t\tmargin-bottom: 1rem;\n\t\t}\n\n\t\t&_middle {\n\t\t\tdisplay: flex;\n\t\t\twidth: 38rem;\n\t\t\tjustify-content: center;\n\t\t\tmargin-top: 2rem;\n\t\t}\n\n\t\t&_list {\n\t\t\twidth: 38rem;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tfont-size: var(--default-font-small);\n\t\t\tmargin-bottom: 2rem;\n\n\t\t\t& > * {\n\t\t\t\tmargin-right: 2rem;\n\t\t\t}\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ba__num": `Admin_ba__num__BLVUo`,
	"ba__card": `Admin_ba__card__L7K1V`,
	"ba__card_btn": `Admin_ba__card_btn__1YTs4`,
	"ba__permits": `Admin_ba__permits__1y+vu`,
	"ba__permits_middle": `Admin_ba__permits_middle__yfnyz`,
	"ba__permits_list": `Admin_ba__permits_list__tdASr`
};
export default ___CSS_LOADER_EXPORT___;
